import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./styles/globals.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root no encontrado en index.html");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
